'use client'

import { useRouter, useSearchParams } from 'next/navigation'

import type { BlogPostCategory, PaginatedResponse } from '@types'

import Button from '@components/buttons/button'
import useSWR from '@hooks/client/useSWR'
import { queryString } from '@lib/helpers/client'

import styles from './categories.module.scss'

export default function Categories(): JSX.Element {
  const router = useRouter()
  const query = useSearchParams()

  const { data: categories } = useSWR<PaginatedResponse<BlogPostCategory[]>>('/blogs/categories', undefined, {
    suspense: true,
    revalidateOnFocus: false,
  })

  const selectCategory = (id: number): void => {
    const isAlreadySelected = id.toString() === query?.get('category')
    router.push(
      `?${queryString({
        ...(!isAlreadySelected ? { category: id } : {}),
        page: '1',
        query: undefined,
      })}`,
    )
  }

  return (
    <>
      {categories &&
        categories?.content?.map((el) => {
          const isSelected = query?.get('category') === el.id.toString()

          return (
            <Button
              key={el.id}
              variant="pink"
              className={`${styles.btn} ${isSelected ? styles.selected : ''}`}
              onClick={(): void => selectCategory(el.id)}
            >
              {el.name}
            </Button>
          )
        })}
    </>
  )
}
